<template>
  <div
    v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || usuarioProyectoId == getUsuarioID">
    <v-container fluid class="white elevation-3 margen d-flex justify-space-between">
      <v-row class="d-flex justify-space-between">

        <v-col cols="12" sm="12" md="4" class="my-auto d-flex">
          <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/proyecto">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <h1>Tareas Proyecto</h1>
        </v-col>

        <v-col cols="12" sm="12" md="4" class="my-auto">
          <span class="mt-2 text-h4 ml-auto">
            {{ mostrarFolio }}
          </span>
        </v-col>

      </v-row>
    </v-container>

    <v-container fluid class="mt-3 mr-4 pa-2 white margen">
      <div class="d-flex justify-space-between">
        <div class="d-flex">
          <span class="text-h5 mx-3">Información.</span>
        </div>
      </div>

      <!-- <v-card :disabled="editar" class="ma-3 pa-3"> -->
      <v-card class="ma-3 pa-3">
        <transition name="fade">
          <v-expansion-panels accordion v-if="mostrarProductos" class="elevation-0 justify-start" focusable multiple>
            <v-card-title style="width: 100%" class="grey lighten-1">
              <div>
                Productos
              </div>
            </v-card-title>

            <v-expansion-panel v-for="producto in productos" :key="producto.PRODUCTO_ID">
              
              <v-expansion-panel-header expand-icon="mdi-menu-down" class="d-flex">
                <v-row>
                  <v-col cols="6" xs="3" sm="3" md="3" class="font-weight-bold">{{ producto.NOMBRE }}</v-col>
                  <v-col cols="6" xs="3" sm="3" md="3" class="font-weight-bold">{{ producto.CLAVE_MSP }}</v-col>
                  <v-col cols="6" xs="6" sm="6" md="6" class="font-weight-bold" style="text-align: right">Agregar Tareas</v-col>
                </v-row>
              </v-expansion-panel-header>

              <v-expansion-panel-content class="">

                <div class="d-flex align-center">
                  <v-text-field label="Descripcion Tarea" v-model="producto.TAREA_DESCRIPCION" class="mx-2"/>
                  <v-icon large color="success" @click="agregarTarea( producto )">mdi-plus-box</v-icon>
                </div>

                <!-- <template> -->
                  <v-data-table :items="producto.TAREAS" :headers="columnasTareas" v-model="tablaModel">
                  </v-data-table>
                <!-- </template> -->

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </transition>

        <div class="d-flex justify-center my-2">
          <v-btn
            class="mx-3 colorP darken-1"
            dark
            small
            text
            :loading="cargandoModificar"
            @click="guardarTareas"
          >
            Guardar.
          </v-btn>
        </div>
      </v-card>
    </v-container>
  </div>
  <v-container v-else-if="!mostrarInformacion">
    <div class="d-flex justify-center">
      <v-card elevation="5">
        <v-card-title>
          <span class="ma-3">Permisos insuficientes.</span>
        </v-card-title>
        <v-card-text>
          <span class="mx-1 font-weight-bold text--primary"
            >No tienes acceso a esta pagina.</span
          >
        </v-card-text>
        <v-card-actions class="mx-2 my-1">
          <v-btn text light class="primary" @click="regresar">
            <v-icon> mdi-arrow-left</v-icon>
            <span>Salir</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
// import Articulos from './Articulos.vue';
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      //DATOS PARA MODIFICAR Y ENVIAR

      //DATOS PARA VALIDACIONES / MOSTRAR INFORMACION
      proyectoID: "",
      mensajeSnack: "",
      colorSnack: "",

      cargandoModificar: false,
      cargandoCliente: false,
      infoProyecto: null,
      editar: true,
      modalFecha: false,
      minFecha: "",
      productos: [],
      
      tablaModel:[],

      mostrarProductos: false,
      mostrarInformacion: false,

      columnasTareas:[
        {text:"TAREA",           value:"TAREA_ID"},
        {text:"DESCRIPCION",      value:"DESCRIPCION"},
      ],

      usuarioProyectoId: "",
      // tiposProyecto: [
      //   {'TIPO':'PROYECTO', 'VALOR':'P'},
      //   {'TIPO':'SERVICIO', 'VALOR':'S'},
      //   ]
    };
  },

  computed: {
    ...mapGetters([
      "getURLAPI",
      "getFechaActual",
      "getUsuario",
      "getUsuarioID",
      "getRolesUsuario",
    ]),

    mostrarFolio: function () {
      if (this.infoProyecto && this.infoProyecto.FOLIO) {
        return this.infoProyecto.FOLIO;
      } else {
        return "";
      }
    },

    iconoFlecha: function () {
      return this.mostrarProductos
        ? "mdi-arrow-up-drop-circle"
        : "mdi-arrow-down-drop-circle";
    },

  },

  methods: {
    // ------------------------------------------------------------------------------
    getInformacionProyecto(id) {
      this.infoProyecto = null;
      this.fechaSeleccionada = "";
      this.archivos = [];
      this.mostrarInformacion = true;
      axios
        .get(`${this.getURLAPI}/Proyecto/informacionProyecto/${id}`)
        .then(({ data }) => {
          console.log(data);
          if (data && data.length > 0) {
            this.infoProyecto = data[0];
            this.usuarioProyectoId = this.infoProyecto.USUARIO_ID;

            for (const arch of data) {
              if (arch.RUTAARCH != null && arch.AESTATUS !== "B") {
                this.archivos.push(arch);
                console.log(arch);
              }
            }
            console.log(this.infoProyecto);
            this.mostrarInformacion = false;
            this.mostrarProductos=true;
          }
        });
    },

    // ------------------------------------------------------------------------------
    async getProductosProyecto(id) {
      try {
        this.productos = (
          await axios.get(
            `${this.getURLAPI}/Proyecto/getProductosProyecto/${id}`
          )
        ).data;
        console.log(this.productos);

        for (const producto of this.productos) {

          this.$set( producto,'TAREAS', [] );

          producto.TAREA_DESCRIPCION = "";
        }
        this.mostrarProductos = true;
      } catch (err) {
        console.log(err);
      }
    },

    // ------------------------------------------------------------------------------
    agregarTarea( producto ){
      if ( producto.TAREA_DESCRIPCION != "" ) {

        // let index = this.productos.indexOf( producto );

        let maxID = 0;
        
        for (let i = 0; i < producto.TAREAS.length; i++) {
          maxID = producto.TAREAS[i].TAREA_ID || 0;
        }

        maxID += 1;

        producto.TAREAS.push({"TAREA_ID": maxID, "DESCRIPCION": producto.TAREA_DESCRIPCION})

        // let editado = {...this.productos[index], ...{producto}}

        // this.productos.splice(index,1,editado)

        // this.$set(this.productos, index, editado)

        // console.log(this.productos,producto.TAREAS);

      }
    },

    // ------------------------------------------------------------------------------
    guardarTareas() {
      try {
        this.cargandoModificar = true;
        let datosForm = new FormData();

        datosForm.append("PROYECTO_ID", this.infoProyecto.PID);
        datosForm.append("PRODUCTOS",   JSON.stringify(this.productos));

        axios
          .post(`${this.getURLAPI}/Proyecto/tareasProyecto`, datosForm)
          .then(({ data }) => {
            console.log(data);

            let estatus = data.STATUS || "ERROR";

            this.$root.vtoast.show({
              message: data.MSG || "Error",
              color: estatus == "OK" ? "success darken-1" : "red darken-1",
              timer: 10000,
              icon: estatus == "OK" ? "mdi-check" : "mdi-alert-circle-outline",
            });

            // this.cargandoModificar = false;
            // this.getInformacionProyecto(this.proyectoID);

            setTimeout( () => {
              this.$router.push({ name: "Proyecto" });

            }, 1000);

          })
          .catch(() => {
            this.cargandoModificar = false;
          });
      } catch (err) {
        this.cargandoModificar = false;
      }
    },

    regresar() {
      this.$router.push({ name: "Proyecto" });
    },
  },

  // ------------------------------------------------------------------------------
  created() {
    document.title = "Modificar Proyecto | Bombas y Suministros del Norte";
    this.proyectoID = this.$route.params["id"];

    this.getInformacionProyecto(this.proyectoID);

    this.minFecha = this.getFechaActual.split(" ");

    this.getProductosProyecto(this.proyectoID);
  },
};
</script>

<style></style>
